import { render, staticRenderFns } from "./Staying_focused.vue?vue&type=template&id=54910a04&"
import script from "./Staying_focused.vue?vue&type=script&lang=js&"
export * from "./Staying_focused.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports